/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const GlobalEmailCaptureFragment = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  GlobalEmailCapture: gql`
    fragment GlobalEmailCaptureQuery on emailCapture_Entry {
      showEmailCapture
      displayMode
      coupon
      displayContent
      displayContentAfterSubmit
      buttonLabel
      saleStart
      saleEnd
      percentage
      countdownDays
    }
  `,
};
